import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { LabelService } from '../../services/label.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-panel',
  standalone: false,
  templateUrl: './confirmation-panel.component.html',
  styleUrl: './confirmation-panel.component.scss',
})
export class ConfirmationPanelComponent {
  @Input() title: string = '';
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  constructor(
    public labelService: LabelService,
    public dialogRef: MatDialogRef<ConfirmationPanelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; infoText: string }
  ) {}

  onCancel() {
    this.cancel.emit();
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.confirm.emit();
    this.dialogRef.close(true);
  }
}
